import { render, staticRenderFns } from "./CollectionBlock.vue?vue&type=template&id=5b7efaac&scoped=true&"
import script from "./CollectionBlock.vue?vue&type=script&lang=js&"
export * from "./CollectionBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7efaac",
  null
  
)

export default component.exports